export default "__VITE_ASSET__DWUVw4yn__"